import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InfoPaymentsComponent } from './components/info-payments/info-payments.component';
import { ModalComponent } from './components/modal/modal.component';
import { ItineraryDetailsComponent } from './components/itinerary-details/itinerary-details.component';
import { CruiseInformationComponent } from './components/cruise-information/cruise-information.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CabinOrdinalNamePipe } from './pipes/cabin-ordinal-name.pipe';
import { LoadingCruiseLeftInformationComponent } from './components/loading-cruise-left-information/loading-cruise-left-information.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { CardComponent } from './components/square/card/card.component';
import { HeartComponent } from './lista-deseos/heart/heart.component';
import { RangeIndividualCalendarComponent } from './components/range-individual-calendar/range-individual-calendar.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RatingComponent } from './components/rating/rating.component';
import { CardReviewComponent } from "./components/card-review/card-review.component";
import { RatingStarComponent } from './components/rating-star/rating-star.component';
import { CruiseInformationTabsComponent } from './components/cruise-information/components/cruise-information-tabs/cruise-information-tabs.component';
import { CruiseInformationAccordionComponent } from './components/cruise-information/components/cruise-information-accordion/cruise-information-accordion.component';
import { CruiseInformationPictureCarouselComponent } from './components/cruise-information/components/cruise-information-picture-carousel/cruise-information-picture-carousel.component';
import { SlickCarouselModule } from "ngx-slick-carousel";
import { CalendarComponent } from './components/calendar/calendar.component';
import { WhastappButtonComponent } from '../core/components/whastapp-button/whastapp-button.component';
import { HeartHeaderComponent } from './lista-deseos/heart-header/heart-header.component';

@NgModule({
    providers: [DatePipe],
    exports: [
        InfoPaymentsComponent,
        ModalComponent,
        ItineraryDetailsComponent,
        CruiseInformationComponent,
        CabinOrdinalNamePipe,
        LoadingCruiseLeftInformationComponent,
        LoadingSpinnerComponent,
        CardComponent,
        HeartComponent,
        RangeIndividualCalendarComponent,
        RatingComponent,
        CardReviewComponent,
        RatingStarComponent,
        CalendarComponent,
        HeartHeaderComponent,
    ],
    imports: [CommonModule, TooltipModule, CollapseModule, LazyLoadImageModule, ReactiveFormsModule, NgbModule, SlickCarouselModule, InfoPaymentsComponent,
        ModalComponent,
        ItineraryDetailsComponent,
        CruiseInformationComponent,
        CabinOrdinalNamePipe,
        LoadingCruiseLeftInformationComponent,
        LoadingSpinnerComponent,
        CardComponent,
        HeartComponent,
        RangeIndividualCalendarComponent,
        RatingComponent,
        CardReviewComponent,
        RatingStarComponent,
        CruiseInformationTabsComponent,
        CruiseInformationAccordionComponent,
        CruiseInformationPictureCarouselComponent,
        CalendarComponent,
        HeartHeaderComponent]
})
export class SharedModule {}
